import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { RouteComponentProps } from 'react-router-dom'

import { Col, Row } from 'react-bootstrap'
import { Button, Card, Icon, Title } from 'src/components'
import { faPlus, faSync } from '@fortawesome/free-solid-svg-icons'

import {
  actions,
  getProviders,
  onDeleteConnection,
} from 'src/actions/cardProvider.actions'

import { cardProviderPermissions } from 'src/enums/permissions'

import { CardProviderList } from 'src/content/CardProviders/CardProvider/CardProviderList'
import {
  handlerError,
  handlerInfoWithButtons,
  handlerSuccess,
  hasErrors,
} from 'src/selectors/error.selector'
import { showAlert } from 'src/actions/alert.actions'
import { isAllowed } from 'src/selectors/modules.selector'

import { loadingSelector } from 'src/selectors/loading.selector'
import { CardProviderDevices } from 'src/content/CardProviders/CardProvider/devices/CardProviderDevices'
import { ICardProviderActions } from 'src/enums/CardProviderEnum'

interface ICardProviderFlags {
  create: boolean
  delete: boolean
  detail: boolean
}

export const CardProvidersPage = ({ history, match }: RouteComponentProps) => {
  const dispatch = useDispatch()

  const loadingDelete = useSelector(state =>
    loadingSelector([actions.DELETE_CARD_CONNECTION])(state),
  )
  const errorDelete = useSelector(state =>
    hasErrors([actions.DELETE_CARD_CONNECTION])(state),
  )

  const canCreate = useSelector(state =>
    isAllowed(state, [cardProviderPermissions.create]),
  )

  const [flags, setFlags] = useState<ICardProviderFlags>({
    create: false,
    delete: false,
    detail: false,
  })

  const [providerDevices, setProviderDevices] = useState<number | undefined>(undefined)

  useEffect(() => {
    setUp()
  }, [])

  useEffect(() => {
    if (loadingDelete) setFlags({ ...flags, delete: true })
    else if (flags.delete) {
      setFlags({ ...flags, delete: true })
      const alert = errorDelete
        ? handlerError(errorDelete.message)
        : {
            ...handlerSuccess(),
            onConfirm: () => setUp(),
          }
      dispatch(showAlert(alert))
    }
  }, [loadingDelete])

  const setUp = () => {
    dispatch(getProviders())
  }

  const onSelect = (provider: ICardProvider, action: ICardProviderActions) => {
    switch (action) {
      case ICardProviderActions.DELETE_CARD_CONNECTION:
        onDeleteProvider(provider)
        break
      case ICardProviderActions.GET_CARD_DEVICES:
        setProviderDevices(provider.id)
        break
    }
  }

  const onDeleteProvider = (provider: ICardProvider) => {
    dispatch(
      showAlert({
        ...handlerInfoWithButtons(
          'Eliminar proveedor',
          `¿Está seguro de eliminar al proveedor ${provider.name}?. Está acción no podrá ser revertida.`,
        ),
        onConfirm: () => dispatch(onDeleteConnection(provider.id)),
      }),
    )
  }

  return (
    <div>
      <Title title={'Proveedores de cobros con tarjeta'} />
      {canCreate && (
        <Row className={'container-buttons'}>
          <Button
            icon={faPlus}
            onClick={() => {
              history.push(`${match.url}/provider`)
            }}>
            Agregar proveedor
          </Button>
        </Row>
      )}
      <Card
        white
        title={'Listado'}
        button={<Icon tooltip={'Recargar'} icon={faSync} onClick={() => setUp()} />}>
        <Row>
          <Col xl={12}>
            <CardProviderList onSelect={onSelect} loadingDelete={loadingDelete} />
          </Col>
        </Row>
      </Card>

      <CardProviderDevices
        providerId={providerDevices}
        onClose={() => setProviderDevices(undefined)}
      />
    </div>
  )
}
